"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientLogo = ClientLogo;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@iconify/react");
function ClientLogo(props) {
    var client = props.client;
    if (client.logo) {
        return (0, jsx_runtime_1.jsx)("img", { src: client.logo, alt: client.display_name, className: "size-10 rounded-md object-contain bg-gray-50 shrink-0" });
    }
    return ((0, jsx_runtime_1.jsx)("div", { className: "flex items-center justify-center size-10 rounded-md bg-primary-navy/10 text-primary-navy shrink-0", children: (0, jsx_runtime_1.jsx)(react_1.Icon, { icon: "solar:buildings-2-linear", fontSize: 18 }) }));
}
